(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-about-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-about-video-dialog')) {
    customElements.define('ck-about-video-dialog', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.trigger = this.querySelector('.ck-about-video__trigger');
        this.dialog = this.querySelector('dialog');
        this.video = this.querySelector('video');
        this.error = this.querySelector('.ck-about-video__error');
        if (!this.trigger || !this.video || typeof this.dialog?.showModal !== 'function') return;
        this.initialized = true;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.trigger.setAttribute('role', 'button');
        this.trigger.addEventListener('click', event => {
          event.preventDefault();
          this.open();
        }, options);
        this.trigger.addEventListener('keydown', event => {
          if (event.key !== ' ') return;
          event.preventDefault();
          this.open();
        }, options);
        this.querySelector('.ck-about-video__close').addEventListener('click', () => this.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        }, options);
        this.dialog.addEventListener('close', () => this.reset(), options);
        this.video.addEventListener('ended', () => this.close(), options);
      }
      open() {
        if (this.dialog.open) return;
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        this.error.hidden = true;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
        const playback = this.video.play();
        if (playback) playback.catch(() => {
          if (this.dialog.open) this.error.hidden = false;
        });
      }
      close() {
        if (!this.dialog.open) return;
        if (document.fullscreenElement === this.video) {
          document.exitFullscreen().catch(() => {}).finally(() => this.dialog.close());
          return;
        }
        this.dialog.close();
      }
      reset() {
        this.video.pause();
        this.video.load();
        this.error.hidden = true;
        if (this.scrollLocked) {
          document.documentElement.style.overflow = this.previousOverflow;
          this.scrollLocked = false;
        }
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        if (!this.initialized) return;
        if (this.dialog.open) this.dialog.close();
        this.reset();
        this.controller.abort();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-dia-di-pais-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-pais-popup')) {
    customElements.define('ck-pais-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.key = 'ck-dia-di-pais-2026-seen';
        this.forced = new URLSearchParams(location.search).get('ck_promo_preview') === '1';
        this.closeHandler = () => this.closePopup();
        this.dialog.querySelector('.ck-pais-close').addEventListener('click', this.closeHandler);
        this.dialog.querySelector('.ck-pais-shop').addEventListener('click', this.closeHandler);
        this.dialog.addEventListener('close', () => this.restoreScroll());
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.closePopup(); });
        this.timer = setTimeout(() => this.showPopup(), Number(this.dataset.delay) || 1500);
      }
      showPopup() {
        if (!this.isConnected || this.dialog.open) return;
        const now = Date.now();
        if (now < Date.parse(this.dataset.start) || now >= Date.parse(this.dataset.end)) return;
        try { if (!this.forced && sessionStorage.getItem(this.key)) return; } catch (_) {}
        if (document.querySelector('dialog[open], .m-cart-drawer--active')) {
          this.timer = setTimeout(() => this.showPopup(), 1500);
          return;
        }
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        try { sessionStorage.setItem(this.key, '1'); } catch (_) {}
      }
      closePopup() { if (this.dialog.open) this.dialog.close(); }
      restoreScroll() { if (this.previousOverflow !== undefined) { document.documentElement.style.overflow = this.previousOverflow; this.previousOverflow = undefined; } }
      disconnectedCallback() { clearTimeout(this.timer); this.restoreScroll(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
